import React, { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconLobbyAccept, IconLobbyReject } from '../../../base/icons/svg';
import { hasRaisedHand } from '../../../base/participants/functions';
import Button from '../../../base/ui/components/web/Button';
import { showLobbyChatButton } from '../../../lobby/functions';
import { ACTION_TRIGGER, MEDIA_STATE } from '../../constants.any';
// import { useLobbyActions } from '../../hooks';
import ParticipantItem from './ParticipantItem';
import Icon from '../../../base/icons/components/Icon';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import { useLobbyActions } from '../../hooks.web';
import { Box } from '@mui/material';
const useStyles = makeStyles()(theme => {
    return {
        button: {
            marginRight: theme.spacing(2)
        },
        moreButton: {
            paddingRight: '6px',
            paddingLeft: '6px',
            marginRight: theme.spacing(2)
        },
        contextMenu: {
            position: 'fixed',
            top: 'auto',
            marginRight: '8px'
        },
        lobbyItem: {
            '&:hover .lobby-group-button': {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }
        }
    };
});
export const LobbyParticipantItem = ({ overflowDrawer, participant: p, openDrawerForParticipant }) => {
    const { id } = p;
    const [admit, reject, chat] = useLobbyActions({ participantID: id });
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const { classes: styles } = useStyles();
    const showChat = useSelector(showLobbyChatButton(p));
    const moreButtonRef = useRef();
    const openContextMenu = useCallback(() => setIsOpen(true), []);
    const closeContextMenu = useCallback(() => setIsOpen(false), []);
    const renderAdmitButton = () => (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.admit')} ${p.name}`, className: styles.button, labelKey: 'participantsPane.actions.admit', onClick: admit, size: 'small', testId: `admit-${id}` }));
    return (React.createElement(Box, { className: styles.lobbyItem },
        React.createElement(ParticipantItem, { actionsTrigger: ACTION_TRIGGER.PERMANENT, audioMediaState: MEDIA_STATE.NONE, displayName: p.name, local: p.local, openDrawerForParticipant: openDrawerForParticipant, overflowDrawer: overflowDrawer, participantID: id, raisedHand: hasRaisedHand(p), videoMediaState: MEDIA_STATE.NONE, youText: t('chat.you') },
            React.createElement(Box, { className: 'lobby-group-button', sx: { display: 'none' } },
                React.createElement(Box, { sx: { marginRight: '8px' } },
                    React.createElement(Tooltip, { content: t('participantsPane.actions.reject'), position: 'bottom' },
                        React.createElement(Icon, { size: 28, onClick: reject, style: { color: '#44494D', alignSelf: 'center', cursor: 'pointer' }, src: IconLobbyReject }))),
                React.createElement(Box, null,
                    React.createElement(Tooltip, { content: t('participantsPane.actions.accept'), position: 'bottom' },
                        React.createElement(Icon, { size: 28, onClick: admit, style: { color: '#44494D', alignSelf: 'center', cursor: 'pointer' }, src: IconLobbyAccept })))))));
};
